import React, { useEffect, useState, useRef} from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Sidebar from '../Sidebar';
import axios from 'axios'

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import { category, tags} from '../Options';
import Multiselect from 'multiselect-react-dropdown';

export default function EditNews() {
    {/**Images states */}
    const [files, setFiles] = useState([]);
    const [filenames, setFilenames] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [message, setMessage] = useState('');
    const [imagePreviews, setImagePreviews] = useState([]);

    //province items
    const [options, setOptions] = useState([])
    const [options2, setOptions2] = useState([])
    //options
    const [selectedOptions, setSelectedOptions] = useState([])
    const [selectedOptions2, setSelectedOptions2] = useState([])

    const navigate = useNavigate()

    
    const [form, setForm] = useState({
        postTitle:'',
        postLink: '',
        postBody:'',
        postExcerpt:'',
        postCategory:[],
        postTags: [],
        postAuthor:'',
        postCreated:'',
        images: [],
    })

    const ref1 = useRef()
    const ref2 = useRef()
    const ref3 = useRef()
    const ref4 = useRef()
    const ref5 = useRef()
    const ref6 = useRef()
    const ref7 = useRef()

    useEffect(()=>{
      setOptions(tags)
      setOptions2(category)
  }, [])

      //date formatting fixture
      function formatDateToYYYYMMDD(inputDate) {
        const dateObject = new Date(inputDate);
        const year = dateObject.getFullYear();
        const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so add 1
        const day = String(dateObject.getDate()).padStart(2, '0');
        
        return `${year}-${month}-${day}`;
        }



    const {_id} = useParams()    
    const token = sessionStorage.getItem('token')

    const gerrit2 = async () =>{
        const response = await fetch(`${process.env.REACT_APP_API_URL}/find-news/${_id}`,{
          headers: {
            'x-access-token': token
          }
        })
        const data = await response.json()
        setForm({...form, 
        postTitle: data.postTitle,
        postLink: data.postLink,
        postBody: data.postBody,
        postExcerpt: data.postExcerpt,
        postTags: data.postTags,
        postCategory: data.postCategory,
        postAuthor:data.postAuthor,
        postCreated:data.postCreated,
        images: data.images,
        })
        setSelectedOptions(data.postTags)
        setSelectedOptions2(data.postCategory)
      }

    useEffect(()=>{
        gerrit2()
    },[])

    const organizeImagesIntoRows = () => {
        const rows = [];
        for (let i = 0; i < imagePreviews.length; i += 3) {
          const row = imagePreviews.slice(i, i + 3);
          rows.push(row);
        }
        return rows;
      };
      const addImageInput = () => {
        if (files.length > 0) {
          alert("Only one image can be uploaded. Please remove the current image before uploading a new one.");
          return;
        }
      
        const input = document.createElement('input');
        input.type = 'file';
        input.className = 'custom-file-input';
        input.required = true;
        input.multiple = false;
        input.addEventListener('change', onChange);
        input.click();
      };
      
  
      const onDeleteImage = () => {
        setFiles([]);
        setFilenames([]);
        setImagePreviews([]);
        setForm((prevObject) => ({
          ...prevObject,
          images: [], 
        }));
      };
      



        const onSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('form', JSON.stringify(form));
        if(files.length !== 0){
            for (let i = 0; i < files.length; i++) {
                formData.append('files', files[i]);
              }
        }
        try {
            await axios.put(`${process.env.REACT_APP_API_URL}/updated-news/${_id}`, formData, {
                headers:{
                    "Content-Type":"multipart/form-data"
                }
            })
            navigate('/news')

        } catch (error) {
           // console.log("Allah maaf kare")
        }
        }

    

        const onChange = (e) => {
          const selectedFile = e.target.files[0]; // Since only one file is allowed
          const selectedFilename = selectedFile.name;
        
          const newImageObject = {
            img_url: `${process.env.REACT_APP_API_URL}/news/${selectedFile.name}`, 
            img_path: '/news/',
          };
        
          // Replace the image in state
          setFiles([selectedFile]);
          setFilenames([selectedFilename]);
          
          setForm((prevObject) => ({
            ...prevObject,
            images: [newImageObject], // Replace the entire array with the new image
          }));
        
          const reader = new FileReader();
          reader.onload = (e) => {
            setImagePreviews([e.target.result]); // Replace existing preview
          };
          reader.readAsDataURL(selectedFile);
        };
        

      useEffect(()=>{
       // console.log(form)
      },[form])


          //dealing with multiple states
    const handleSelectStateOptions =  (selectedList)=>{
      setSelectedOptions(selectedList)
    }
    useEffect(()=>{
      setForm({...form, postTags: selectedOptions})
    },[selectedOptions])

    useEffect(()=>{
     // console.log(form)
    }, [form.postTags])

    const handleSelectStateOptions2 =  (selectedList)=>{
      setSelectedOptions2(selectedList)
    }
    useEffect(()=>{
      setForm({...form, postCategory: selectedOptions2})
    },[selectedOptions2])

    useEffect(()=>{
     // console.log(form)
    },[form])
  return (
<>

<div className="sidebar">
<Sidebar/>
</div>
    <div id="bydrop">
        <h1>Edit News</h1>
   <form onSubmit={onSubmit}>


<div >
    <label for="formGroupExampleInput2" class="form-label">Tags</label>
            <Multiselect 
              options={options}
              displayValue='name' 
              selectedValues={selectedOptions}
              onSelect={handleSelectStateOptions}
              onRemove={(selectedList) => {
                setSelectedOptions(selectedList);
            }}
              closeOnSelect={false}
              avoidHighlightFirstOption
              required
            />
    </div>
    <div >
    <label for="formGroupExampleInput2" class="form-label">Category</label>
            <Multiselect 
              options={options2}
              displayValue='name' 
              selectedValues={selectedOptions2}
              onSelect={handleSelectStateOptions2}
              onRemove={(selectedList) => {
                setSelectedOptions2(selectedList);
            }}
              closeOnSelect={false}
              avoidHighlightFirstOption
              required
            />

    </div>
<div className="row">
    <div className="col-md-6">
            {/**Post Title */}
    <label for="formGroupExampleInput" class="form-label">Title</label>
    <div class="input-group input-group-sm mb-3">
        <input required ref={ref1} value= {form.postTitle} onChange={e => setForm({...form, postTitle: e.target.value})} type="text" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
    </div>
    </div>

    <div className="col-md-6">
            {/**Post Author*/}
    <label for="formGroupExampleInput" class="form-label">Author</label>
    <div class="input-group input-group-sm mb-3">
        <input required ref={ref2} value= {form.postAuthor}  onChange={e => setForm({...form, postAuthor: e.target.value})} type="text" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
    </div>
    </div>
</div>

<div className="row">
    <div className="col-md-6">
    {/**Post Link */}
    <label for="formGroupExampleInput" class="form-label">Excerpt</label>
    <div class="input-group input-group-sm mb-3">
        <input ref={ref5} required  value= {form.postExcerpt}  onChange={e => setForm({...form, postExcerpt: e.target.value})} type="text" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
    </div>
    </div>

    <div className="col-md-6">

    {/**Post Link */}
    <label for="formGroupExampleInput" class="form-label">Link</label>
    <div class="input-group input-group-sm mb-3">
        <input ref={ref7} required  value= {form.postLink}  onChange={e => setForm({...form, postLink: e.target.value})} type="text" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
    </div>
    </div>
</div>

<div className="row">
    <div className="col-md-6">
    {/**Post Creates */}
    <label for="formGroupExampleInput" class="form-label">Date</label>
    <div class="input-group input-group-sm mb-3">
        <input required ref={ref3}  value= {formatDateToYYYYMMDD(form.postCreated)}  onChange={e => setForm({...form, postCreated: e.target.value})} type="date" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
    </div>
    </div>

    {form.images.length > 0 && (
  <div className="custom-file mb-4">
    <img style={{ width: '100%' }} src={form.images[0].img_url} alt="Image Preview" />
    <p className="text-center">{filenames[0]}</p>
    <button type="button" onClick={onDeleteImage} style={{ color: "white", backgroundColor: "red", border: "1px solid red", borderRadius: "3px" }}>
      x
    </button>
  </div>
)}

<div className="row">
  <div className="col-md-3">
    <button type="button" className="btn btn-primary" onClick={addImageInput}>
      + Add Cover Photo 
    </button>
  </div>
</div>


          {/* <div className="row mt-4">
          {organizeImagesIntoRows().map((row, rowIndex) => (
            <div>
              {row.map((preview, index) => (
                  <div>
                    <div className="container-1" >
                  <img className='img-1' src={preview} alt="Image Preview" />
                  
                  </div>
                  <p  className="text-center">{filenames[index]}</p>
                  </div>
              ))}
            </div>
            ))}
            </div> */}


          
</div>



    {/**Post Body */}
    <label for="formGroupExampleInput" class="form-label">Body </label>


                <CKEditor
                    editor={ ClassicEditor }
                    data={form.postBody}
                    onReady={ editor => {
                       // console.log( 'Editor is ready to use!', editor );
                    } }
                    onChange={ ( event, editor ) => {
                      const data = editor.getData();
                      setForm({...form, postBody: data})
                  } }
                    onBlur={ ( event, editor ) => {
                       // console.log( 'Blur.', editor );
                    } }
                    onFocus={ ( event, editor ) => {
                       // console.log( 'Focus.', editor );
                    } }
                />
                       <button type="submit" class="btn btn-secondary" style={{marginTop:"20px"}}>Submit</button>
    
    </form>
  
            
        {message ? <p>{message}</p> : null}
    </div>
</>
  );
}
